export default "__VITE_ASSET__B5Av_7B7__"